import { uniqid } from "Libs/uniqid";

export class Core {
  /**
   * @param {domNode} domElem
   * @param {String} className
   */
  constructor(domElem, className) {
    const datajs = JSON.parse(domElem.getAttribute("data-js") || "{}");
    !datajs[className] && (datajs[className] = {});
    datajs[className].id = className + "_" + uniqid();
    domElem.setAttribute("data-js", JSON.stringify(datajs));

    this.className = className;
    this.domElem = domElem;
    this.params = datajs[className];
    this._modCache = {};
    this.constructor.instances[this.params.id] = this;
    this.setMod("js", "inited");
  }

  getElemNode(name) {
    return this.domElem.querySelector(
      "."
        .concat(this.constructor.className)
        .concat(Core.ELEM_DELIM)
        .concat(name)
    );
  }

  getElemsNode(name) {
    return this.domElem.querySelectorAll(
      "."
        .concat(this.constructor.className)
        .concat(Core.ELEM_DELIM)
        .concat(name)
    );
  }

  getId() {
    return this.params.id;
  }

  getMod(modName) {
    var modCache = this._modCache;
    return modName in modCache
      ? modCache[modName] || ""
      : (modCache[modName] = this._extractModVal(modName));
  }

  delMod(modName) {
    this.setMod(modName, false);
  }

  setMod(modName, modVal) {
    var typeModVal = typeof modVal,
      className = this.className,
      modClasName = className + Core.MOD_DELIM + modName,
      curModVal = this.getMod(modName);

    if (typeModVal === "undefined") {
      modVal = true;
    } else if (typeModVal === "boolean") {
      modVal === false && (modVal = "");
    } else {
      modVal = modVal.toString();
      modVal !== "" && (modClasName += Core.MOD_DELIM + modVal);
    }

    if (curModVal == modVal) return;

    if (curModVal) {
      var curModValIsBool = typeof curModVal === "boolean";

      if (modVal === "") {
        !curModValIsBool && (modClasName += Core.MOD_DELIM + curModVal);
      } else {
        this.domElem.classList.remove(
          className +
            Core.MOD_DELIM +
            modName +
            (curModValIsBool ? "" : Core.MOD_DELIM + curModVal)
        );
      }
    }

    this.domElem.classList[modVal ? "add" : "remove"](modClasName);
    this._modCache[modName] = modVal;

    this._emit("modChange", {
      modName: modName,
      modVal: modVal,
      oldModVal: curModVal,
    });

    return this;
  }

  /**
   * Checks whether a BEM entity has a modifier
   * @param {String} modName Modifier name
   * @param {String|Boolean} [modVal] Modifier value. If not of type String or Boolean, it is casted to String
   * @returns {Boolean}
   * @see https://github.com/bem/bem-core/blob/v4/common.blocks/i-bem/i-bem.vanilla.js#L245
   */
  hasMod(modName, modVal) {
    var typeModVal = typeof modVal,
      className = this.className + "_" + modName;

    if (typeModVal === "undefined") {
      modVal = true;
    } else if (typeModVal === "boolean") {
      modVal === false && (modVal = "");
    } else {
      modVal = modVal.toString();
      className += "_" + modVal;
    }

    return this.domElem.classList.contains(className);
  }

  /**
   * @see https://github.com/bem/bem-core/blob/88d5f569564073a5418caa573fbb5740bc977871/common.blocks/i-bem-dom/i-bem-dom.js#L700
   */
  _extractModVal(modName) {
    var domNode = this.domElem,
      matches;
    domNode &&
      (matches = domNode.className.match(this._buildModValRE(modName)));
    return matches ? matches[2] || true : "";
  }

  _buildModValRE(modName) {
    return new RegExp(
      "(\\s|^)" +
        this._buildModClassNamePrefix(modName) +
        "(?:" +
        Core.MOD_DELIM +
        "(" +
        Core.NAME_PATTERN +
        "))?(?=\\s|$)"
    );
  }

  _buildModClassNamePrefix(modName) {
    return this.getEntityName() + Core.MOD_DELIM + modName;
  }

  getEntityName() {
    return this.className;
  }

  /**
   * Generate and dispath custom event
   * @param {String} eventName
   * @param {Object} eventData
   */
  _emit(eventName, eventData) {
    var detail = eventData || {};
    !detail.target && (detail.target = this);
    this.domElem.dispatchEvent(
      new CustomEvent(eventName, {
        detail: detail,
        bubbles: true,
        cancelable: true,
      })
    );
  }

  destroy() {
    var instaces = this.constructor.instances;

    for (var key in instaces) {
      if (instaces.hasOwnProperty(key)) {
        var element = instaces[key];
        element == this && delete instaces[key];
      }
    }

    this.delMod("js", "inited");
  }

  /**
   * Separator for modifiers and their values
   * @const
   * @type String
   */
  static MOD_DELIM = "_";
  /**
   * Separator between names of a block and a nested element
   * @const
   * @type String
   */
  static ELEM_DELIM = "__";
  /**
   * Pattern for acceptable element and modifier names
   * @const
   * @type String
   */
  static NAME_PATTERN = "[a-zA-Z0-9-]+";

  static getInstance(domElem) {
    var instaces = this.prototype.constructor.instances;
    return domElem
      ? instaces[
          (
            JSON.parse(domElem.getAttribute("data-js") || "{}")[
              this.prototype.constructor.className
            ] || {}
          ).id
        ]
      : null;
  }

  static getInstanceCollection(domCollection = []) {
    return Array.prototype.map.call(
      domCollection,
      function (domElem) {
        return this.getInstance(domElem);
      },
      this
    );
  }
}
